export default "__VITE_ASSET__BojvEDzk__"